import type { Reducer } from 'redux';

import type { Action } from 'modules/global/generic.types';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/leads/actionTypes';
import type { LeadsTarget } from 'modules/leads/types';

const removeDeletedLead = (ids: Array<string>, { payload: leadId }: Action<unknown>): Array<string> =>
  ids.filter(id => id !== leadId);

/**
 * Builds the state of one leads list: the ids, page and loading flag of the fetches dispatched for its target.
 * @param target the list the fetches are dispatched for
 * @param additionalReducers the slices the list owns besides the search ones
 */
export const createLeadsListReducer = <A extends Record<string, Reducer>>(target: LeadsTarget, additionalReducers: A) =>
  createSearchReducers(
    types.FETCH_REQUEST,
    {
      global: { matcher: ({ meta }: Action) => meta?.target === target, paginationSlice: true },
      ids: { [types.DELETE_LEAD_SUCCESS]: removeDeletedLead },
    },
    additionalReducers
  );
